export function minOrZero(val: number | undefined, min: number): boolean {
  if (typeof val === "undefined") return true;
  return val >= min || val === 0;
}
